import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listCompany } from '@/api/dealer.js';
export default {
  name: 'base-qualifications-index',
  components: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    return {
      licenseUploadFileList: [],
      businessUploadFileList: [],
      manuUploadFileList: [],
      uploadFilePrefixURL: null,
      initialized: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.uploadFilePrefixURL = process.env.VUE_APP_OSS_URL + '/';

                if (that.initialized) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return that.loadData();

              case 5:
                that.initialized = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;

                if (!that.dataLoading) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                that.dataList = [];
                that.dataLoading = true;
                _context2.next = 7;
                return listCompany({
                  pageSize: 1,
                  page: 1,
                  all_examine_status: true
                }).then(function (res) {
                  if (res.list.length > 0) {
                    var row = res.list[0];
                    that.licenseUploadFileList = row.business_license_photo ? JSON.parse(row.business_license_photo) : [];
                    that.businessUploadFileList = row.picture_business_license ? JSON.parse(row.picture_business_license) : [];
                    that.manuUploadFileList = row.manu_license_photo ? JSON.parse(row.manu_license_photo) : [];
                  }
                });

              case 7:
                that.dataLoading = false;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};